export interface LabelData {
  id: string;
  name: string;
}

export interface LocationAlertStatus {
  id: number;
  locations: {
    id: number;
    name: string;
  };
  created_at: string;
  is_active: boolean;
}

export enum LocationAlertType {
  HEALTH_INDEX = "health_index"
}

export interface LocationAlertData {
  id: number;
  type: LocationAlertType;
  details: any;
  notify_on_alert: boolean;

  labels: LabelData[];

  recent_statuses: LocationAlertStatus[];

  created_at: string;
  created_by: number;
  last_modified_at: string;
  last_modified_by: number;
}
